import { FC } from 'react'
import { translate } from 'shared/translation'
import { NETWORK_ERROR_CODE, NOT_FOUND_CODE } from 'shared/constants'
import Loading from '../Loading'
import styles from './Error.module.scss'

type ErrorProps = {
  onButtonClicked: () => void
  errorCode?: number
  minHeight: number
  isLoading: boolean
}

const Error: FC<ErrorProps> = ({ onButtonClicked, minHeight, isLoading, errorCode }) => {
  const getTitle = () => {
    switch (errorCode) {
      case NETWORK_ERROR_CODE:
        return translate('network_error_title')
      case NOT_FOUND_CODE:
        return translate('not_found_title')
      default:
        return translate('common_error_title')
    }
  }

  const getDescription = () => {
    switch (errorCode) {
      case NETWORK_ERROR_CODE:
        return translate('network_error_desc')
      case NOT_FOUND_CODE:
        return translate('not_found_desc')
      default:
        return translate('common_error_desc')
    }
  }

  const getButtonText = () => {
    switch (errorCode) {
      case NOT_FOUND_CODE:
        return translate('back_to_home')
      default:
        return translate('try_again')
    }
  }

  return (
    <div
      className={styles.container}
      style={{ minHeight: `${minHeight}px` }}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <img
            className={styles.warning}
            alt="warning"
            src={`${process.env.PUBLIC_URL}/images/warning.png`}
          />
          <div className={styles.errorTitle}>{getTitle()}</div>
          <div className={styles.errorDesc}>{getDescription()}</div>
          <button
            onClick={onButtonClicked}
            className={styles.errorButton}
          >
            {getButtonText()}
          </button>
        </>
      )}
    </div>
  )
}

export default Error
